export const DEFAULT_PAGE_SIZE = 25;

export interface PaginationApiResponse<T> {
  total: number;
  page: number;
  page_size: number;
  content: T[];
}

export interface Pagination<T> {
  list: T[];
  total: number;
}

export interface PaginationOptions {
  sortBy?: string;
  sortDesc?: boolean;
  page?: number;
  pageSize?: number;
}

export function getPaginationApiParams(options: PaginationOptions): URLSearchParams {
  const queryParams = new URLSearchParams();

  if (options.sortBy) {
    queryParams.set('sort', options.sortBy);
    queryParams.set('sort_direction', options.sortDesc ? 'DESC' : 'ASC');
  }

  const page = options.page ?? 0;
  const pageSize = options.pageSize ?? DEFAULT_PAGE_SIZE;

  queryParams.set('page', page.toString());
  queryParams.set('page_size', pageSize.toString());

  return queryParams;
}
